import { lazy, Suspense } from 'react';

import { Modal } from '@/components/ui/Modal';
import { Button } from '@/components/ui/Button';

interface PrivacyPolicyProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * M1 — Политика конфиденциальности.
 * Источник: docs/legal/privacy_policy.md (отребрендирован в commit 386c345
 * под Mini App «АйТи-Профиль» / defined term «Сервис»).
 *
 * Контент рендерится через react-markdown и lazy-load — тяжёлый markdown +
 * сама библиотека уезжают в отдельный chunk, который грузится при ПЕРВОМ
 * открытии модалки. Это сохраняет main bundle slim для Welcome.
 */
const PrivacyPolicyContent = lazy(() => import('./legal/PrivacyPolicyContent'));

export function PrivacyPolicy({ isOpen, onClose }: PrivacyPolicyProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Политика конфиденциальности">
      <div className="flex flex-col gap-3">
        <Suspense fallback={<LegalContentFallback />}>
          {isOpen && <PrivacyPolicyContent />}
        </Suspense>
        <div className="pt-2">
          <Button onClick={onClose} fullWidth size="md">
            Понятно
          </Button>
        </div>
      </div>
    </Modal>
  );
}

function LegalContentFallback() {
  return (
    <div className="flex justify-center py-8" aria-label="Загрузка текста">
      <span
        role="status"
        className="inline-block h-8 w-8 animate-spin rounded-full border-2 border-border border-t-accent"
      />
    </div>
  );
}
